import Vue from 'vue'
import Element from 'element-ui'
import VueI18n from 'vue-i18n'
import elementEN from 'element-ui/lib/locale/lang/en'
import elementCN from 'element-ui/lib/locale/lang/zh-CN'
import elementTW from 'element-ui/lib/locale/lang/zh-TW'
import elementTH from 'element-ui/lib/locale/lang/th'
import { lang } from '@/utils/Config' 
import ZHS from './zh-s.js'
import ZHT from './zh-t.js'
import EN from './en.js'
import TH from './th.js'

Vue.use(VueI18n)
const { NODE_ENV } = process.env

const config = {
  'en': {
    local: NODE_ENV.includes('dev') ? EN : {},
    ...elementEN
  },
  'zh-s': {
    local: NODE_ENV.includes('dev') ? ZHS : {},
    ...elementCN
  },
  'zh-t': {
    local: NODE_ENV.includes('dev') ? ZHT : {},
    ...elementTW
  },
  'th': {
    local: NODE_ENV.includes('dev') ? TH : {},
    ...elementTH
  }
}
const messages = {}
messages[lang] = config[lang]

const i18n = new VueI18n({
  locale: lang,
  messages
})

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})

export { i18n, messages }
